import { request } from './index'
import { HTTP_METHODS } from './const'

export default function getSkinnyBanners() {
  return request({
    url: 'v6/skinny-banners',
    method: HTTP_METHODS.get,
  })
}
